const commonKeys = {
  /** Must match api-dashboard AppAuthorizeToken:Electron (see appsettings.json). */
  electronAppAuthorizeToken:
    '/mUm1hTH3xEJaLx/OUlUWX+eHtTL7DnIj0FdUJ21Uas=',
  gmapsKey: 'AIzaSyAVS6G1zw5h34r_sI1w6qMVyjkhRhS6ahw',
  sentryDsn: 'https://b181e5e16dc941d48e89f567f441bed1@o491159.ingest.sentry.io/5556330',
  s3AssetsUrl: 'https://cdn.swaypay.io/assets',
  googleClientId:
    '137867530826-p5ac8f5ekves51ph8vb6k35bssih15g4.apps.googleusercontent.com',
  microsoftClientId: '4e646c4a-4b25-466f-a6ae-3f1ccad01f78',
  microsoftTenantId: '87a865c9-817d-4213-be05-d2e247a09179'
}

const envConfigs = {
  local: {
    socketUrl: 'ws://localhost:5008/connect',
    apiUrl: 'http://localhost:5008/api',
    ...commonKeys
  },
  dev: {
    socketUrl: 'wss://dev-api-dashboard.directful.com/connect',
    alertSocketUrl: 'wss://dev-api-user-alerts.directful.com/connect',
    apiUrl: 'https://dev-api-dashboard.directful.com/api',
    inviteMediaBaseUrl: 'https://dev-cdn.swaypay.io/Outbound/Media/Text',
    coreApiUrl: 'https://dev-api-core.directful.com/api',
    ...commonKeys
  },
  sbx: {
    socketUrl: 'wss://sbx-api-dashboard.directful.com/connect',
    apiUrl: 'https://sbx-api-dashboard.directful.com/api',
    alertSocketUrl: 'wss://sbx-api-user-alerts.directful.com/connect',
    inviteMediaBaseUrl: 'https://sbx-cdn.swaypay.io/Outbound/Media/Text',
    coreApiUrl: 'https://sbx-api-core.directful.com/api',
    ...commonKeys
  },
  prod: {
    socketUrl: 'wss://api-dashboard.directful.com/connect',
    apiUrl: 'https://api-dashboard.directful.com/api',
    //apiUrl: 'http://localhost:5008/api',
    alertSocketUrl: 'wss://api-user-alerts.directful.com/connect',
    inviteMediaBaseUrl: 'https://cdn.swaypay.io/Outbound/Media/Text',
    coreApiUrl: 'https://api-core.directful.com/api',
    ...commonKeys
  }
}

export const debugConfig = envConfigs.prod

export const currentEnvironment = 'Production'.startsWith('#')
  ? 'local'
  : 'Production'

const prodConfig = {
  socketUrl: 'wss://api-dashboard.directful.com/connect',
  apiUrl: 'https://api-dashboard.directful.com/api',
  scriptUrl:
    'https://web-code.swaypay.net/swaypay/script.js?t=' +
    Math.random(),
  alertSocketUrl: 'wss://api-user-alerts.directful.com/connect',
  inviteMediaBaseUrl: 'https://cdn.swaypay.io/Outbound/Media/Text',
  coreApiUrl: 'https://api-core.directful.com/api',
  ...commonKeys
}

export const pushPublicKey =
  'BMoyf2DI9Jve4mj9DqHRvWm78Qc-qdOovE1kMzBtIP-fZsTJ0GQma8YaK34oDhDuTdD_D2NZG96SSHOayM8PWpw'

export default window.location.hostname === 'localhost' ? debugConfig : prodConfig
